import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const initialState = {
  data: {
    tenantId: '',
    orderToken: '',
    seoName: '',
    seoTitle: '',
    seoDescription: '',
    taxPickupOrders: false,
    taxShippedOrders: false,
    taxStates: false,
    taxByBillingAddress: false,
    clientLogo: '',
    heroImg: '',
    showNavbar: true,
    showHero: true,
    showFooter: true,
    theme: 'default',
    layout: 'default',
    promoText: '',
    promoText2: '',
    promoText3: '',
    promoSubtext: '',
    promoTextMobile: '',
    promoText2Mobile: '',
    promoText3Mobile: '',
    promoSubtextMobile: '',
    promoColor: '',
    promoHighlightColor: '',
    promoBackgroundColor: '',
    promoLink: '',
    shippingOptions: [],
    countdownEndDate: '',
    countdownText1: '',
    countdownText2: '',
    countdownText3: '',
    countdownText1Mobile: '',
    countdownText2Mobile: '',
    countdownText3Mobile: '',
    countdownBackgroundColor: '',
    countdownTextColor: '',
  },
};

function globalSettings(state = initialState, action) {
  switch (action.type) {
    case types.GLOBAL_SETTINGS_FETCH_ERROR:
    case types.GLOBAL_SETTINGS_EDIT_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.GLOBAL_SETTINGS_FETCH_SUCCESS:
    case types.GLOBAL_SETTINGS_EDIT_SUCCESS:
      return assign({}, state, {
        data: action.res
      }
      );
    case types.GLOBAL_SETTINGS_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    case types.SHIPPING_OPTIONS_EDIT_SUCCESS:
        return assign({}, state, {
          data: action.res
        })
    case types.SHIPPING_OPTIONS_EDIT_ERROR:
      return assign({}, state, {
        error: action.res,
      }
      );
    default:
      return state;
  }
}

export default globalSettings;



// WEBPACK FOOTER //
// ./src/reducers/globalSettings.js